import React from 'react';
import PropTypes from 'prop-types';

const USER_FACING_REASONS = {
  complaint_rate: 'too many recipients reported messages as spam',
  bounce_rate: 'too many messages could not be delivered',
  ses_tenant_paused: 'our email provider temporarily paused outgoing mail for your company',
};

const getEmailBlockContextLine = (reason) => {
  const fullReason = USER_FACING_REASONS[reason] ?? reason;
  return `This usually happens when ${fullReason}.`;
};

export const getEmailBlockFromMetadata = (metadata = {}) => {
  if (metadata.skipped !== true) {
    return { blocked: false };
  }
  return {
    blocked: true,
    reason: metadata.reason,
    blockId: metadata.blockId,
  };
};

const emailBlockedDescription = (reason) => {
  const contextLine = getEmailBlockContextLine(reason);
  return (
    <>
      Email sending is temporarily paused.
      {contextLine && (
        <>
          {' '}
          {contextLine}
        </>
      )}
      {' '}
      Our support team can help restore sending when it is safe again.
    </>
  );
};

export function EmailBlockedTimelineText({ reason, kind = 'default' }) {
  if (kind === 'welcome') {
    const contextLine = getEmailBlockContextLine(reason);
    return (
      <div>
        The new user was created, but their welcome email was not sent because email sending is temporarily paused.
        {contextLine && (
          <>
            {' '}
            {contextLine}
          </>
        )}
        {' '}
        Our support team can help restore sending when it is safe again.
      </div>
    );
  }
  return <div>{emailBlockedDescription(reason)}</div>;
}

EmailBlockedTimelineText.propTypes = {
  reason: PropTypes.string,
  kind: PropTypes.oneOf(['default', 'welcome']),
};

EmailBlockedTimelineText.defaultProps = {
  reason: undefined,
  kind: 'default',
};
